import { defineStore } from "pinia";

export const useConfigFiltersStore = defineStore("configFilters", {
  state: () => {
    return {
      owned: false,
    };
  },
});
